import { QueryClientProvider } from '@tanstack/react-query';
import { CatchBoundary, RouterProvider } from '@tanstack/react-router';

import CssBaseline from '@mui/material/CssBaseline';
import { StyledEngineProvider, ThemeProvider } from '@mui/material/styles';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';

import { Composer, Error } from '@src/components/utils';
import { AlertProvider, AuthenticationProvider, PermissionsProvider } from '@src/context';
import { useAuthentication } from '@src/context/hooks';
import { Devtools } from '@src/corelib/devtools';
import { queryClient } from '@src/corelib/query';
import router from '@src/router';
import { theme } from '@src/themes';

import './styles/global.css';
import { useAPIClient } from './api';


const PROVIDERS = [
  { element: ThemeProvider, props: { theme: theme } },
  { element: StyledEngineProvider, props: { injectFirst: true } },
  { element: LocalizationProvider, props: { dateAdapter: AdapterDateFns } },
  { element: AuthenticationProvider, props: {} },
  { element: PermissionsProvider, props: {} },
  { element: QueryClientProvider, props: { client: queryClient } },
  { element: AlertProvider, props: {} },
];

function InnerApp() {
  const auth = useAuthentication();
  const apiClient = useAPIClient();
  return <RouterProvider router={router} context={{ auth, apiClient }} />;
}

function App() {
  return (
    <CatchBoundary getResetKey={() => 'reset'} errorComponent={Error}>
      <Composer providers={PROVIDERS}>
        <CssBaseline />
        <InnerApp />
        <Devtools router={router} />
      </Composer>
    </CatchBoundary>
  );
}

export default App;
